import {createAnatomy} from '@zag-js/anatomy';

export const pieChartAnatomy = createAnatomy(`pie-chart`).parts(`container`, `totalLabel`);

export const parts = pieChartAnatomy.build();

export type Part = keyof typeof parts;
